import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        if (this.isDismissed()) {
            this.element.remove();
        }
    }
    dismiss() {
        this.persistDismissal();
        this.element.remove();
    }
    storageKey() {
        return `alert:dismissed:${this.keyValue}`;
    }
    isDismissed() {
        return localStorage.getItem(this.storageKey()) === "true";
    }
    persistDismissal() {
        localStorage.setItem(this.storageKey(), "true");
    }
}
default_1.values = {
    key: String,
};
export default default_1;
